import { ContextualMenu, Dialog, DialogFooter, IDialogFooterStyles } from '@fluentui/react';
import React, { useContext } from 'react';
import { trackEvent } from '../../../services';
import { ReviewContext } from '../../review/ReviewContextProvider';
import { SalusPrimaryButton } from '../SalusPrimaryButton';

const stylesNextButton: IDialogFooterStyles = {
  actions: {},
  actionsRight: { textAlign: 'center' },
  action: {}
};

export interface NextCaseButtonProps {
  isEnabled: boolean;
  multipleCases: boolean;
  onClick: () => void;
}

export const NextCaseModal: React.FunctionComponent<NextCaseButtonProps> = props => {
  const { state } = useContext(ReviewContext);
  const nextCasePromptText = props.multipleCases
    ? `You have run out of time to submit feedback on these cases and they have been placed back in the queue.
  Click 'Next Cases' to get more cases.`
    : `You have run out of time to submit feedback on this case and it has been placed back in the queue.
  Click 'Next Case' to get another case.`;
  const nextCaseButtonText = props.multipleCases ? 'Next Cases' : 'Next Case';
  const onClick = () => {
    trackEvent('NextCaseClick', {
      component: 'NextCaseModal',
      eventType: 'click',
      caseIds: state.cases?.map(elem => elem.case.id)
    });
    props.onClick();
  };
  return (
    <Dialog
      isBlocking={true}
      hidden={!props.isEnabled}
      dialogContentProps={{
        title: 'Timer expired',
        subText: nextCasePromptText
      }}
      modalProps={{
        dragOptions: {
          moveMenuItemText: 'Move',
          closeMenuItemText: 'Close',
          menu: ContextualMenu
        },
        overlay: {
          isDarkThemed: true
        }
      }}
    >
      <DialogFooter styles={stylesNextButton}>
        <SalusPrimaryButton onClick={onClick} text={nextCaseButtonText} />
      </DialogFooter>
    </Dialog>
  );
};
